<script setup lang="ts">
defineProps<{
    imageSrc: string;
    alt: string;
}>();
</script>

<template>
    <div class="img-card">
        <span>
            <img :src="imageSrc" :alt="alt" />
            <slot />
        </span>
    </div>
</template>

<style scoped>
.img-card {
    min-height: 261px;
}

.img-card span {
    background: var(--pure-white);
    padding: 1.5rem;
    display: block;
    height: 100%;
}

.img-card span img {
    margin: auto;
    margin-bottom: 0.5rem;
    display: block;
    height: 100px;
}
</style>
